/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Control the calculation of various prices.
 */
export interface QuoteControl {
  /**
   * In case of true the calculation of all regular available prices is enabled.   Default: false
   */
  calculateRegularPrices?: boolean;
  /**
   * In case of true the calculation of reference prices is enabled.   Default: false
   */
  calculateReferencePrices?: boolean;
  /**
   * This defines a set of special price calculations. These calculations are agent specific.   Example: *Rabattstaffel_15*, *CALC_TEI_AND_VOL*
   */
  calculateAdditionalPrices?: Array<string>;
}
